var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Tooltip",
    {
      attrs: {
        title: "Invite sent",
        tooltipClasses: "w-full",
        disabled: _vm.disabled,
        placement: "bottom",
        fullWidth: _vm.fullWidth,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }